import React from "react";

interface Props {
  size?: number;
  theme?: "light" | "dark";
}

/**
 * Compact Orbit mark — Saturn-O.
 *
 * Solid disc planet wrapped by a thin tilted orbit ring with a satellite dot.
 * All visual properties are inline SVG attributes — no external CSS needed.
 * The disc uses currentColor so it inherits from the parent text color.
 */
export function OrbitMark({ size = 22, theme = "dark" }: Props) {
  const isDark = theme === "dark";
  const ringStroke = "#4FB3FF";
  const satellite = "#7FCBFF";
  const textColor = isDark ? "#FFFFFF" : "#0E1F4A";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ color: textColor }}
    >
      <g transform="translate(40 40) rotate(-20)">
        <path
          d="M -32 0 A 32 8 0 0 1 32 0"
          fill="none"
          stroke={ringStroke}
          strokeWidth={4}
          strokeLinecap="round"
          opacity={0.35}
        />
      </g>
      <circle cx="40" cy="40" r={25} fill="currentColor" />
      <g transform="translate(40 40) rotate(-20)">
        <path
          d="M 32 0 A 32 8 0 0 1 -32 0"
          fill="none"
          stroke={ringStroke}
          strokeWidth={4}
          strokeLinecap="round"
        />
        <circle cx={32} cy={0} r={4} fill={satellite} />
      </g>
    </svg>
  );
}
